import CustomInput from "../CustomInput";
import { ReactComponent as Search } from 'assets/common/searchW.svg'
import CustomButton from "../CustomButton";
import { ReactComponent as Close } from 'assets/header/close.svg'
import { useSetAtom } from "jotai";
import { hsCodeResultAtom } from "atom/hsCode";
import { useState } from "react";
import { toast } from "react-toastify";
import { jsonAxios } from "components/axios";
import { ReactComponent as Del } from 'assets/quote/del.svg'

interface IHsCodeModal {
    isOpen: boolean,
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
}

const HsCodeModal = ({ isOpen, setIsOpen }: IHsCodeModal) => {
    interface IUnit2 {
        HS_CD2: string,
        RATIO: string,
        HS_CD2_NM: string
    }

    interface IUnit10 {
        HS_CD10_NM: string,
        HS_CD10: string,
        RATIO: string,
        TARIFF: string,
        NEW_TOTAL_GODS: string
    }

    interface IHsCode2 {
        hscode2: string,
        hscode2Name: string
    }

    const setHsCodeResult = useSetAtom(hsCodeResultAtom);
    const [text, setText] = useState<string>('')
    const [hsCode2, setHsCode2] = useState<IHsCode2>({} as IHsCode2)
    const [listUnit2, setListUnit2] = useState<IUnit2[]>([]);
    const [listUnit10, setListUnit10] = useState<IUnit10[]>([]);
    const [once, setOnce] = useState<boolean>(false);
    const [direct, setDirect] = useState<string>('');
    const [tab, setTab] = useState<number>(1);

    const tHeader = [
        { label: "HS Code", flex: 1 },
        { label: "HS Code 이름", flex: 1.5 },
        { label: "신고비율", flex: 0.5 },
        { label: "기본세율", flex: 0.5 },
        { label: "상품 설명", flex: 1.2 },
    ];

    const searchHsCode = (hscode?: string) => {
        if (!text) return toast.error('검색어를 입력해주세요.')
        setOnce(true)
        const reqData = {
            word: text,
            service: hscode ? '003' : '002',
            hsCode2: hscode
        }
        jsonAxios.post('hscode', reqData).then(res => {
            if (res.data.code === 200) {
                if (hscode) {
                    setListUnit10(res.data.data.HS_CD_UNIT10)
                }
                else {
                    setListUnit2(res.data.data.HS_CD_UNIT2)
                }
            }
            else if (res.data.code === 400) {
                toast.error('시스템 오류입니다.')
            }
            else if (res.data.code === 401) {
                toast.error(res.data.message)
                setHsCode2({} as IHsCode2)
                setListUnit2([])
                setListUnit10([])
            }
            setOnce(false)
        })
    }

    const selectHsCode = (label: string) => {
        setHsCodeResult(label)
        close();
    }

    const close = () => {
        setText('')
        setHsCode2({} as IHsCode2)
        setListUnit2([])
        setListUnit10([])
        setDirect('')
        setIsOpen(false);
    }

    if (!isOpen) return null;

    return (
        <div className="z-[100] fixed">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                <div className="bg-white shadow-lg p-6 rounded-lg w-[660px] tablet:w-96 max-h-[80vh] overflow-y-auto">
                    <div className='flex flex-col gap-6 font-semibold text-center'>
                        <div className='flex flex-col items-start gap-3'>
                            <div className="flex justify-between items-center mb-6 w-full">
                                <p className='text-2xl'>HS CODE 간편조회</p>
                                <Close className='cursor-pointer' onClick={() => {
                                    close();
                                }
                                } />
                            </div>
                            <p className='text-[#9D9EB7] text-left'>
                                PulseOnShip에서 제공하는 HS CODE 간편 조회는 참고용 입니다. <br />
                                정확한 품목 분류는 관세청 또는 관세사에 문의하시기 바랍니다.
                            </p>
                        </div>

                        <div className="flex items-center gap-10">
                            <label htmlFor="tab1" className="flex items-center gap-2">
                                <input
                                    className="accent-primary"
                                    type="radio"
                                    name="tab"
                                    id="tab1"
                                    value={0}
                                    checked={tab === 0}
                                    onChange={(e) => {
                                        setTab(Number(e.target.value))
                                    }} />
                                품목검색
                            </label>
                            <label htmlFor="tab2" className="flex items-center gap-2">
                                <input
                                    className="accent-primary"
                                    type="radio"
                                    name="tab"
                                    id="tab2"
                                    value={1}
                                    checked={tab === 1}
                                    onChange={(e) => {
                                        setTab(Number(e.target.value))
                                    }} />
                                직접입력
                            </label>
                        </div>
                        {
                            tab === 0 ?
                                <div className="flex tablet:flex-col gap-6">
                                    <CustomInput
                                        type="text"
                                        value={text}
                                        disabled={!!hsCode2.hscode2}
                                        placeholder="품목명을 입력하시기 바랍니다."
                                        onChange={(e) => {
                                            setText(e.target.value)
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                searchHsCode();
                                            }
                                        }}
                                    />
                                    <CustomButton
                                        className='bg-primary !min-w-400'
                                        Icon={Search}
                                        disabled={!!hsCode2.hscode2 || once}
                                        title='검색'
                                        onClick={() => searchHsCode()}
                                    />
                                </div> :

                                <div className="flex tablet:flex-col gap-6">
                                    <CustomInput
                                        type="text"
                                        value={direct}
                                        placeholder="HSCODE를 입력하시기 바랍니다."
                                        onChange={(e) => {
                                            setDirect(e.target.value)
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                if (!direct) return toast.error('hsCode를 입력해주세요,')
                                                selectHsCode(direct);
                                            }
                                        }}
                                    />
                                    <CustomButton
                                        className='bg-primary !min-w-400'
                                        disabled={!!hsCode2.hscode2 || once}
                                        title='입력'
                                        onClick={() => selectHsCode(direct)}
                                    />
                                </div>
                        }

                        {
                            tab === 0 ?
                                <>
                                    {
                                        hsCode2.hscode2 &&
                                        <div className="flex justify-between items-center gap-4 p-4 border rounded-lg">
                                            <p>HS Code 2 : {hsCode2.hscode2}, {hsCode2.hscode2Name}</p>
                                            <Del className="cursor-pointer" onClick={() => {
                                                setHsCode2({} as IHsCode2)
                                            }} />
                                        </div>
                                    }
                                    <div className="flex flex-col border-[#9D9EB7] border-1 rounded-lg h-[450px] overflow-hidden overflow-y-auto">
                                        <div className='flex bg-[#EEF4FF] border-[#9D9EB7] border-b font-semibold tablet:text-xs text-sm'>
                                            {
                                                hsCode2.hscode2 ?
                                                    tHeader.map((item, idx) => (
                                                        <div
                                                            key={idx}
                                                            className={`flex-[${item.flex}] flex items-center justify-center h-15 px-2 ${idx !== tHeader.length - 1 ? 'border-r border-[#9D9EB7]' : ''} tablet:h-10`}
                                                        >
                                                            {item.label}
                                                        </div>
                                                    )) :
                                                    tHeader.slice(0, 3).map((item, idx) => (
                                                        <div
                                                            key={idx}
                                                            className={`flex-[${item.flex}] flex items-center justify-center h-15 px-2 ${idx !== tHeader.slice(0, 3).length - 1 ? 'border-r border-[#9D9EB7]' : ''} tablet:h-10`}
                                                        >
                                                            {item.label}
                                                        </div>
                                                    ))
                                            }
                                        </div>

                                        {
                                            hsCode2.hscode2 ?
                                                (
                                                    listUnit10.length > 0 ?
                                                        listUnit10.map((item, idx) => (
                                                            <div
                                                                className='flex hover:bg-[#EEF4FF] py-4.5 border-[#9D9EB7] border-b-1 font-medium text-sm transition-all cursor-pointer'
                                                                key={idx}
                                                                onClick={() => {
                                                                    selectHsCode(item.HS_CD10)
                                                                }}
                                                            >
                                                                <div className='flex flex-[1] justify-center items-center px-2'>
                                                                    {item.HS_CD10}
                                                                </div>
                                                                <div className='flex flex-[1.5] justify-center items-center px-2'>
                                                                    {item.HS_CD10_NM}
                                                                </div>
                                                                <div className='flex flex-[0.5] justify-center items-center px-2'>
                                                                    {Number(item.RATIO).toFixed(2)}%
                                                                </div>
                                                                <div className='flex flex-[0.5] justify-center items-center px-2'>
                                                                    {Number(item.TARIFF).toFixed(2)}%
                                                                </div>
                                                                <div className='flex flex-[1.2] justify-center items-center px-2'>
                                                                    {item.NEW_TOTAL_GODS}
                                                                </div>
                                                            </div>
                                                        )) :
                                                        <div className="flex flex-1 justify-center items-center">검색어를 입력해주세요</div>
                                                ) :
                                                listUnit2.length > 0 ?
                                                    listUnit2.map((item, idx) => (
                                                        <div
                                                            className='flex hover:bg-[#EEF4FF] py-4.5 border-[#9D9EB7] border-b-1 font-medium text-sm transition-all cursor-pointer'
                                                            key={idx}
                                                            onClick={() => {
                                                                setHsCode2({
                                                                    hscode2: item.HS_CD2,
                                                                    hscode2Name: item.HS_CD2_NM
                                                                })
                                                                searchHsCode(item.HS_CD2)
                                                            }}
                                                        >
                                                            <div className='flex flex-[1] justify-center items-center px-2'>
                                                                {item.HS_CD2}
                                                            </div>
                                                            <div className='flex flex-[1.5] justify-center items-center px-2'>
                                                                {item.HS_CD2_NM}
                                                            </div>
                                                            <div className='flex flex-[0.5] justify-center items-center px-2'>
                                                                {Number(item.RATIO).toFixed(2)}%
                                                            </div>
                                                        </div>
                                                    )) :
                                                    <div className="flex flex-1 justify-center items-center">검색어를 입력해주세요</div>
                                        }
                                    </div>
                                </> :
                                <></>
                        }

                    </div>
                </div>
            </div>
        </div>
    );
}

export default HsCodeModal;